<div class="container-fluid">
  <div class="chat-wrap card">

    <!-- Left: conversation list -->
    <div class="chat-list">
      <div class="chat-list-header">
        <div>
          <h6 class="mb-0 text-uppercase">Bot Messages</h6>
          <small class="text-muted">
            {{ isSearching ? (conversations.length + ' with matches') : (conversations.length + ' conversations') }} · via WhatsApp Bot
          </small>
        </div>
        <button class="btn btn-outline-primary btn-sm" (click)="refresh()" [disabled]="loading">
          {{ loading ? '...' : 'Refresh' }}
        </button>
      </div>

      <div class="chat-search">
        <input type="text" class="form-control form-control-sm"
          placeholder="Search all conversations..."
          [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" />
        <button *ngIf="isSearching" class="chat-search-clear" title="Clear search"
          (click)="clearSearch()">✕</button>
      </div>

      <div class="chat-list-body">
        <div *ngIf="loading" class="text-center text-muted p-3">
          <span class="spinner-border spinner-border-sm"></span>
        </div>
        <div *ngIf="!loading && conversations.length === 0" class="text-center text-muted p-4">
          {{ isSearching ? 'No messages match your search.' : 'No messages yet.' }}
        </div>
        <div class="chat-item" *ngFor="let c of conversations"
          [class.active]="c.number === selectedNumber" (click)="selectConversation(c)">
          <div class="avatar" [style.background]="color(c)">{{ initials(c) }}</div>
          <div class="chat-item-body">
            <div class="chat-item-top">
              <span class="chat-item-name">{{ c.name || displayNumber(c.number) }}</span>
              <span class="chat-item-time">{{ lastMessage(c)?.createdAt | date:'shortTime' }}</span>
            </div>
            <div class="chat-item-number">{{ displayNumber(c.number) }}</div>
            <div class="chat-item-preview">{{ preview(c) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right: conversation thread -->
    <div class="chat-thread">

      <div class="sending-overlay" *ngIf="sending">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-2 fw-semibold">Sending…</div>
      </div>

      <ng-container *ngIf="selectedConversation as conv; else noConv">
        <div class="chat-thread-header">
          <div class="avatar sm" [style.background]="color(conv)">{{ initials(conv) }}</div>
          <div>
            <div class="fw-bold">{{ conv.name || displayNumber(conv.number) }}</div>
            <small class="text-muted">{{ displayNumber(conv.number) }}</small>
          </div>
        </div>

        <div class="chat-messages">
          <div class="message-row" *ngFor="let m of conv.messages" [class.out]="m.direction === 'out'">
            <div class="bubble" [class.bubble-out]="m.direction === 'out'">
              <ng-container *ngIf="isAudio(m); else notAudio">
                <audio *ngIf="m.audioUrl" controls [src]="m.audioUrl" class="audio-player"></audio>
                <span *ngIf="!m.audioUrl" class="text-muted small">
                  {{ m.loadingMedia ? 'Loading voice message...' : '🎙 Voice message' }}
                </span>
              </ng-container>
              <ng-template #notAudio>
                <ng-container *ngIf="hasMedia(m); else textMsg">
                  <button class="btn btn-sm btn-light" (click)="openMedia(m)">📎 Open {{ m.messageType }}</button>
                  <div *ngIf="m.text" class="mt-1">{{ m.text }}</div>
                </ng-container>
                <ng-template #textMsg><span style="white-space: pre-wrap;">{{ m.text }}</span></ng-template>
              </ng-template>
              <div class="bubble-time">{{ m.createdAt | date:'shortTime' }}</div>
            </div>
          </div>
        </div>

        <div class="chat-composer">
          <input type="file" #attachInput hidden
            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,video/*,audio/*"
            (change)="onAttachSelected($event)" />
          <button class="btn btn-light" title="Attach file" (click)="attachInput.click()"
            [disabled]="sending || recording">📎</button>
          <button class="btn btn-light" [class.recording]="recording"
            [title]="recording ? 'Stop recording' : 'Record voice note'"
            (click)="toggleRecording()" [disabled]="sending">
            {{ recording ? '⏹' : '🎙' }}
          </button>

          <input type="text" class="form-control" placeholder="Type a reply..."
            [(ngModel)]="replyText" (keyup.enter)="sendReply()" [disabled]="sending || recording" />

          <span *ngIf="recording" class="recording-label">● Recording…</span>

          <button class="btn btn-primary" (click)="sendReply()"
            [disabled]="sending || recording || !replyText.trim()">
            {{ sending ? '...' : 'Send' }}
          </button>
        </div>
      </ng-container>

      <ng-template #noConv>
        <div class="d-flex align-items-center justify-content-center h-100 text-muted">
          Select a conversation to view messages
        </div>
      </ng-template>
    </div>

  </div>
</div>
